var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('v-row',{attrs:{"align":"center","justify":"center"}},[_c('v-btn',{attrs:{"type":"submit","depressed":"","block":"","color":"primary"}},[_vm._v(_vm._s(this.title))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }